import React from "react";
import ReactDOM from "react-dom/client";
//import './index.css';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ProjectProvider } from "./context/ProjectContext";
import ThemeContext from "./context/ThemeContext";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
 <React.StrictMode>
 <Provider store={store}>
 <BrowserRouter
 basename="/"
 future={{
 v7_startTransition: true,
 v7_relativeSplatPath: true,
 }}
 >
 <ThemeContext>
 <ProjectProvider>
 <App />
 </ProjectProvider>
 </ThemeContext>
 </BrowserRouter>
 </Provider>
 </React.StrictMode>,
);

reportWebVitals();
